import { CreateNoteData } from '@/helpers/hubspot/types';
import logError from '@/helpers/logError';
import { Dispatch } from 'react';
import { ReplaceInPersonFormState } from '../constants';
import { ReplaceInPersonFormActionMap } from '../reducer';
import { getHubspotDeal } from './getHubspotDeal';

export const createNoteWithAttachmentAndAddToDeal = async (
	state: ReplaceInPersonFormState,
	dispatch: Dispatch<ReplaceInPersonFormActionMap>,
	dealId?: string,
) => {
	let hubspotDealId: string | undefined | null = dealId;
	if (!hubspotDealId) {
		hubspotDealId = await getHubspotDeal(state, dispatch);
	}

	const fileIdString = state.pictures.map((file) => file.id).join(';');

	const noteBody: CreateNoteData = {
		files: fileIdString,
		dealId: hubspotDealId || '',
		body: 'Homeowner uploaded attachments',
	};

	const response = await fetch(`/api/hubspot/note/`, {
		method: 'POST',
		body: JSON.stringify(noteBody),
	});

	if (!response.ok) {
		logError(new Error('Failed to create a note with attachment(s)'));
		// dispatch({ type: ActionTypes.SET_REJECTED, payload: null });
		// throw new Error('Failed to create a note with attachment(s)');
	}

	return response.ok;
};
